function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Zedbloxa{fill-rule:evenodd;fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23e8ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9230ff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-855.666 -144.733)"
}, /*#__PURE__*/React.createElement("path", {
  className: "Zedbloxa",
  d: "M871.23,185.629a2.3,2.3,0,0,1,0-3.249,2.354,2.354,0,0,1,3.248,0,2.3,2.3,0,0,1-3.248,3.249Zm2.979-5.464V168.722l11.679,6.488-10.342,5.745A4.153,4.153,0,0,0,874.208,180.165Zm-14.4-4.96,11.687-6.493v11.453a4.04,4.04,0,0,0-1.337.789Zm27.52-15.287v12.993l-11.687-6.492,2.894-1.607-.028.006Zm-16.1-9.469a2.354,2.354,0,1,1,1.623.65A2.3,2.3,0,0,1,871.229,150.448Zm-1.267-4.519a4.078,4.078,0,0,0-1.13,3.575l-12.469,6.927a1.355,1.355,0,0,0,0,2.369l13.7,7.61-13.7,7.61a1.355,1.355,0,0,0,0,2.369l12.47,6.927a4.081,4.081,0,1,0,8.042.009l12.469-6.926a1.355,1.355,0,0,0,.7-1.185v-17.6c0-.022-.005-.044-.007-.067a1.347,1.347,0,0,0-.014-.144,1.291,1.291,0,0,0-.027-.129c-.011-.041-.023-.081-.038-.122a1.436,1.436,0,0,0-.058-.135c-.01-.02-.015-.041-.026-.06s-.021-.029-.031-.045a1.232,1.232,0,0,0-.083-.12c-.026-.033-.051-.066-.079-.1s-.063-.063-.1-.093-.065-.057-.1-.083-.073-.048-.111-.07-.073-.043-.112-.061-.082-.033-.124-.048-.082-.028-.124-.038-.082-.017-.123-.023-.1-.012-.147-.015c-.018,0-.035-.005-.053-.005s-.043.005-.065.006a1.355,1.355,0,0,0-.148.015q-.064.01-.125.026c-.043.011-.085.024-.126.039a1.239,1.239,0,0,0-.133.057c-.02.01-.041.016-.061.026l-15.175,8.429-13.042-7.245,10.343-5.746a4.056,4.056,0,0,0,5.59-.158,4.089,4.089,0,0,0-5.782-5.782Z",
  transform: "translate(0 0)"
}));

var SvgZedblox = function SvgZedblox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.374,
    height: 43.363,
    viewBox: "0 0 34.374 43.363",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZedblox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Zedblox.3694373c.svg";
export { ForwardRef as ReactComponent };